/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { wrapCollectionLayout, LoadMoreButton } from "@quintype/components";
import { CustomLink } from "../custom-link";
import "./one-col-story-list.module.css";
import { VerticalStory } from "../basic/vertical-story-card/vertical-story";
import PropTypes from "prop-types";
import get from "lodash/get";
import { AdService } from "../../components/ad-service";
import { CollectionName } from "../atoms/collection-name/index.js";
import { isEager, getRowMetadata, updateStoriesWithAlternatives, getStoryUrl } from "../../utils";

function OneColStoryListBase({ stories, associatedMetadata, config, collection, onLoadMore, noMoreStories, index }) {
  const pbAheadConfig = getRowMetadata(config, associatedMetadata);
  const { show_collection_title: collectionName = true, limitStories = 0 } = pbAheadConfig;
  const eager = isEager(index, true);
  if (limitStories) stories = stories.slice(0, limitStories);

  const enableLoadMoreButton =
    typeof get(associatedMetadata, ["enable_load_more_button"]) === "boolean" &&
    get(associatedMetadata, ["enable_load_more_button"]);
  stories = updateStoriesWithAlternatives(stories, false);

  return (
    <div styleName="component-wrapper" data-testid="one-col-story-list">
      {!collectionName ? null : <CollectionName name={collection.name} config={config} section={collection} />}
      <div styleName="one-col-story-list-wrapper">
        <div styleName="vertical-stories-wrapper" data-testid="vertical-stories-wrapper">
          {stories.map(story => {
            return story ? (
              <CustomLink href={getStoryUrl(story)} key={story.id}>
                <VerticalStory eager={eager} story={story} config={config} />
              </CustomLink>
            ) : null;
          })}
        </div>
        <div className="app-ad app-ad--vertical">
          <AdService
            adtype="Vertical-Ad"
            layoutName="FullscreenMediaList"
            collectionSlug={config["collection-slug"]}
            slotId={`OneColStoryList-${index}`}
          />
        </div>
      </div>
      {associatedMetadata && enableLoadMoreButton && !noMoreStories && (
        <LoadMoreButton className="load-more-button" onLoadMore={onLoadMore} text="Load More" />
      )}
    </div>
  );
}

OneColStoryListBase.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object),
  config: PropTypes.object,
  collection: PropTypes.object,
  associatedMetadata: PropTypes.object,
  onLoadMore: PropTypes.func,
  noMoreStories: PropTypes.bool,
  index: PropTypes.number
};

OneColStoryListBase.storyList = 16;

export const OneColStoryList = wrapCollectionLayout(OneColStoryListBase);
